@if (viewData$ | async; as data) {
    @if (data.tree && data.tree.children.length) {
        <ms-item class="list-title" [title]="data.tree.title" [arrow]="false" />
        @for (item of data.tree.children; track item) {
            <ng-container
                [ngTemplateOutlet]="leagueTemplate"
                [ngTemplateOutletContext]="{ $implicit: item, type: data.type, promoMap: data.promoMap, index: $index, last: $last }" />
        }
        @if (data.tree.moreTitle) {
            <ds-divider />
            <ms-item class="list-all" [title]="data.tree.moreTitle" [href]="data.tree.href" (click)="moreClicked(data.type)" />
        }
    }
}

<ng-template #leagueTemplate let-item let-index="index" let-type="type" let-last="last" let-promoMap="promoMap">
    @if (isSeparator(item)) {
        <div class="separator-item">{{ item.title }}</div>
    } @else {
        <ms-list-item
            [title]="item.title"
            [subTitle]="item.region"
            [arrow]="false"
            [href]="item.href"
            [count]="getCount(item)"
            [badge]="true"
            [icon]="getIcon(item)"
            [isShowBorder]="!last"
            (click)="itemClicked(item, type, index)">
            <span class="icon-alignment" item-icon>
                @if (!isLeagueOrVirtualGroup(item)) {
                    <span [ngClass]="item.icon"></span>
                } @else if (isLeagueOrVirtualGroup(item) && !item.icon) {
                    <ms-favourite-league-toggle
                        item-icon
                        class="favourite-icon"
                        [id]="getItemFavouriteId(item)"
                        [name]="item.title"
                        [sport]="item.sport" />
                }
            </span>
            @if (isLeagueOrVirtualGroup(item)) {
                @if (hasCompetitionLogo(item.sport, item.id, item.imageProfile)) {
                    <span class="logo-alignment" competition-logo>
                        <ms-competition-logo [sportId]="item.sport" [leagueId]="item.id" [imageProfile]="item.imageProfile" />
                    </span>
                }
                <div class="item-title" badge>
                    <div class="item-title-container">
                        <div [ngClass]="{ 'priceboost-wrapper': isPriceBoost(!!item.priceBoostCount) }">
                            @if (isPriceBoost(!!item.priceBoostCount)) {
                                <ms-priceboost-count-signpost [count]="item.priceBoostCount" />
                            }
                        </div>
                        @if (!item.region && promoMap[item.id]) {
                            <ms-promotion-badge />
                        }
                        <div [ngClass]="{ 'badges-wrapper': promoMap[item.id] }">
                            @if (promoMap[item.id]) {
                                <ms-promotion-badge />
                            }
                        </div>
                    </div>
                </div>
            }
        </ms-list-item>
    }
</ng-template>
